import React, { useCallback } from "react";

// your formatter
const formatToPrecision = (value, precision) => {
  if (!value || isNaN(value)) return "";
  return parseFloat(Number(value).toFixed(precision));
};

// debounce helper
function debounce(fn, delay) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
}

export default function FormattedInput({
  value,
  onValueChange,
  precision = 2,
  debounceDelay = 500,
  disabled = false,
  className,
  ...rest
}) {
  // debounced formatter
  const debouncedFormat = useCallback(
    debounce((val) => {
      onValueChange(formatToPrecision(val, precision));
    }, debounceDelay),
    [onValueChange, precision, debounceDelay]
  );

  const handleChange = (e) => {
    const val = e.target.value;

    // always update immediately
      if (!val || isNaN(val)) {
      return;
    }
    onValueChange(val);

  

    // update with formatted value after pause
    debouncedFormat(val);
  };

  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
      disabled={disabled}
      className={className}
      {...rest}
    />
  );
}
